import React, { useState } from 'react';
import { SwatchColorPicker, ColorPicker, getColorFromString } from '@fluentui/react';
import { Eyedropper16Regular, Dismiss16Regular } from '@fluentui/react-icons';
import PropTypes from 'prop-types';
import { useOnClickOutside } from '@bingads-webui-campaign-react/asset-library-components';


const defaultSwatch = [
  { id: 'red', label: 'red', color: '#C20734' },
  { id: 'pink', label: 'pink', color: '#ECABCE' },
  { id: 'gold', label: 'gold', color: '#E3BC67' },
  { id: 'yellow', label: 'yellow', color: '#F8E3AC' },
  { id: 'gray', label: 'gray', color: '#E7E7E7' },
  { id: 'teal', label: 'teal', color: '#4DBAA9' },
  { id: 'blue', label: 'blue', color: '#0E92BE' },
  { id: 'darkblue', label: 'darkblue', color: '#5074B9' },
  { id: 'lavender', label: 'lavender', color: '#BAB8E7' },
  { id: 'maroon', label: 'maroon', color: '#6F146E' },
  { id: 'midnight', label: 'midnight', color: '#112355' },
];

export const CreativeColorPicker = ({
  color,
  elementName,
  onShowColorEditor,
  showColorPicker,
  setShowColorPicker,
  swatch,
  updateSelectedColors,
  logger,
}) => {
  const [colorPickerColor, setColorPickerColor] = useState(getColorFromString(color.color));

  const onEyeDropperClick = () => {
    setShowColorPicker(!showColorPicker);
  };

  const onSwatchChanged = (_e, _id, newColor) => {
    setColorPickerColor(getColorFromString(newColor));
    setShowColorPicker(false);
    updateSelectedColors({ ...color, color: newColor });
    onShowColorEditor(null);
    logger.logTrace(`Creative Editor: Color Swatch changed - ${elementName}`);
  };

  const onColorPickerChange = (_e, newColor) => {
    setColorPickerColor(newColor);
    updateSelectedColors({ ...color, color: newColor.str });
    logger.logTrace(`Creative Editor: Color Picker changed - ${elementName}`);
  };

  const onClose = () => {
    setShowColorPicker(false);
    onShowColorEditor(null);
  };

  const { targetRef } = useOnClickOutside({ onClickOutside: onClose });

  return (
    <div className="creative-color-editor-container">
      <div className="creative-color-editor-elements">
        <div className="creative-color-swatch" style={{ display: 'flex' }}>
          <Eyedropper16Regular
            onClick={onEyeDropperClick}
            className="eye-dropper"
          />
          <SwatchColorPicker
            columnCount={swatch.length}
            cellShape="square"
            colorCells={swatch}
            onChange={(e, id, newColor) => onSwatchChanged(e, id, newColor)}
            className="swatch-colors"
          />
          <Dismiss16Regular className="close-swatch" onClick={onClose} />
        </div>
        {showColorPicker && (
          <div ref={targetRef} className="color-picker-container">
            <ColorPicker
              className="color-picker"
              alphaType="none"
              color={colorPickerColor}
              onChange={(e, id, newColor) => onColorPickerChange(e, id, newColor)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

CreativeColorPicker.propTypes = {
  color: PropTypes.shape({
    elementName: PropTypes.string,
    suffix: PropTypes.string,
    editable: PropTypes.bool,
    color: PropTypes.string,
  }).isRequired,
  elementName: PropTypes.string.isRequired,
  onShowColorEditor: PropTypes.func.isRequired,
  showColorPicker: PropTypes.bool.isRequired,
  setShowColorPicker: PropTypes.func.isRequired,
  swatch: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    color: PropTypes.string,
  })),
  updateSelectedColors: PropTypes.func.isRequired,
  logger: PropTypes.shape({
    logTrace: PropTypes.func,
  }).isRequired,
};

CreativeColorPicker.defaultProps = {
  swatch: defaultSwatch,
};
